/**
 * The composer's time zone notice (D-CHAT-01/S08):
 * "Alice is in a different time zone (GMT+9) · Local time: 01:23."
 * Uses the peer's first name and their 24-hour local time.
 */
export function timezoneNoticeText(displayName: string, gmtOffset: string, timeZone?: string, now: Date = new Date()): string {
    const firstName = displayName.trim().split(/\s+/)[0] || displayName;
    let localTime: string;
    try {
        localTime = now.toLocaleTimeString('en-GB', {timeZone, hour: '2-digit', minute: '2-digit', hour12: false});
    } catch {
        localTime = '';
    }
    const tail = localTime ? ` · Local time: ${localTime}.` : '.';
    return `${firstName} is in a different time zone (${gmtOffset})${tail}`;
}
